export default {
  GET_LIST: '/manage/activity/list',
  EXPORT_LIST: '/manage/activity/exportList',
  CAN_DOWNLOAD: '/auth/document/preview/file',
  CAN_DOWNLOAD_DETAIL: '/auth/document/preview/detail/file'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/activityLog.js